<template>
  <div class="d-flex align-center">
    <!-- Success State -->
    <div v-if="normalizedValue === 100" class="progress-wrapper">
      <v-progress-circular
        :value="100"
        :size="size"
        :width="width"
        color="#38b000"
      >
        <v-icon color="#38b000" :size="size">
          mdi-check
        </v-icon>
      </v-progress-circular>
    </div>

    <!-- Percentage State -->
    <div v-else class="progress-wrapper">
      <v-progress-circular
        :value="normalizedValue"
        :size="size"
        :width="width"
        color="#38b000"
        rotate="-90"
      >
        <span class="progress-text">{{ normalizedValue }}%</span>
      </v-progress-circular>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    size: {
      type: Number,
      default: 24,
    },
    width: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    normalizedValue() {
      const parsedValue = Number(this.value);

      if (Number.isNaN(parsedValue)) {
        return 0;
      }

      return Math.min(100, Math.max(0, Math.round(parsedValue)));
    },
  },
};
</script>

<style scoped>
.progress-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.progress-text {
  font-size: 8px;
  font-weight: 500;
  color: #374151;
}

/* Make track color light gray */
.v-progress-circular >>> svg circle:first-child {
  stroke: #EAEAEADE !important;
}
</style>